// extracted by mini-css-extract-plugin
module.exports = {"title":"Testimonials_title__xZS6C","dot":"Testimonials_dot__2hgiq","activeDot":"Testimonials_activeDot__MxtQI"};